var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      class: _vm.svgClass,
      attrs: {
        width: _vm.size,
        height: _vm.size,
        fill: _vm.fill,
        "aria-hidden": "true",
      },
    },
    [_c("use", { attrs: { "xlink:href": _vm.iconName } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }